import { Box, Stack, Typography } from "@mui/material";
import { useState } from "react";
import Atomic from "../../../../AComponent/Atomic";

const { Input, Button } = Atomic;

const AddParameter = ({ onDone }) => {
  const [state, setState] = useState({
    ParameterName: "",
    ParameterShortName: "",
    ParameterDescription: "",
  });
  const onChangeHandler = (value, type) => {
    setState((prevState) => ({ ...prevState, [type]: value }));
  };

  return (
    <Stack
      rowGap={"1rem"}
      height={"25rem"}
      width={"35rem"}
      className="scroll"
      alignItems={"flex-start"}
    >
      <Typography variant="h3">Add KPI</Typography>
      <Input
        type={"text"}
        label={`KPI Name`}
        onChange={(value) => {
          onChangeHandler(value, "ParameterName");
        }}
        value={state.ParameterName}
        styles={{ width: "100%" }}
        rows={5}
        containerStyles={{ width: "90%" }}
      />
      <Input
        type={"text"}
        label={`KPI Description`}
        onChange={(value) => {
          onChangeHandler(value, "ParameterDescription");
        }}
        value={state.ParameterDescription}
        styles={{ width: "100%" }}
        rows={5}
        containerStyles={{ width: "90%" }}
      />
      <Box flex={1}></Box>
      <Button
        label={"Done"}
        onClick={() => {
          onDone(state);
        }}
      />
    </Stack>
  );
};

export default AddParameter;
